import { render, staticRenderFns } from "./adminTemplateEdit.vue?vue&type=template&id=8a9c0930&scoped=true&"
import script from "./adminTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./adminTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9c0930",
  null
  
)

export default component.exports